<!-- Ported from the Polaris kit: src/product/components/AddRuleField.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first.
     Hand changes (phase 4.4): `placeholder` and `label` are props (Guardrails and Guidelines say different things;
     the kit's own words are the defaults, in i18n). -->
<script setup>
// A field to write a new rule and add it: Enter or the button. An empty rule is not added. With `categories`
// (Fase 3, guidance por categoria), a leading select picks the category and `add` carries it.
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { Add16 } from '@carbon/icons-vue';
import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from '../ui/input-group';
import OptionSelect from './OptionSelect.vue';

const props = defineProps({
  placeholder: { type: String, default: '' },
  label: { type: String, default: '' },
  // [{ value, label }]: com a lista, o campo emite add(texto, categoria).
  categories: { type: Array, default: () => [] },
});
const emit = defineEmits(['add']);
const { t } = useI18n();
const text = ref('');
const category = ref('');
watch(
  () => props.categories,
  categories => {
    if (categories.length && !category.value)
      category.value = categories[0].value;
  },
  { immediate: true }
);
const add = () => {
  const value = text.value.trim();
  if (!value) return;
  emit('add', value, category.value);
  text.value = '';
};
</script>

<template>
  <InputGroup data-add-rule-field>
    <InputGroupAddon v-if="categories.length" align="inline-start">
      <OptionSelect
        v-model="category"
        :options="categories"
        size="sm"
        :aria-label="t('POLARIS.PAGES.ADD_RULE.CATEGORY_LABEL')"
      />
    </InputGroupAddon>
    <InputGroupInput
      v-model="text"
      :aria-label="props.label || t('POLARIS.PAGES.ADD_RULE.LABEL')"
      :placeholder="
        props.placeholder || t('POLARIS.PAGES.ADD_RULE.PLACEHOLDER')
      "
      @keydown.enter.prevent="add"
    />
    <InputGroupAddon align="inline-end">
      <InputGroupButton
        type="button"
        variant="secondary"
        :disabled="!text.trim()"
        @click="add"
      >
        <Add16 aria-hidden="true" />
        {{ t('POLARIS.PAGES.SUGGESTED.ADD') }}
      </InputGroupButton>
    </InputGroupAddon>
  </InputGroup>
</template>
